import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@cotyorg/ccx-atoms/Picture';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import R from 'ramda';
import SectionHeader from '../../../atoms/SectionHeader';

export const GroupPhotoSection = ({ sectionHeading, images }) => (
  <div className="article-section">
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <SectionHeader>
            <Paragraph alignment="center">
              {R.prop('subheading', sectionHeading)}
            </Paragraph>
          </SectionHeader>
        </div>
      </div>
    </div>
    <Picture
      alt={R.path([0, 'alt'], images)}
      src={R.path([0, 'imageSrc'], images)}
      srcset={R.path([0, 'imageSrcSet'], images)}
    />
  </div>
);

GroupPhotoSection.propTypes = {
  sectionHeading: PropTypes.instanceOf(PropTypes.object),
  images: PropTypes.instanceOf(PropTypes.array),
};
